var map = {
	"./Broncos.svg": "FBPW",
	"./Bulldogs.svg": "aeyP",
	"./Cowboys.svg": "u+Pv",
	"./Dolphins.svg": "rrlt",
	"./Dragons.svg": "OLWw",
	"./Eels.svg": "ojeU",
	"./Knights.svg": "NDae",
	"./Manly.svg": "vvjD",
	"./Panthers.svg": "wOb3",
	"./Rabbitohs.svg": "qoUC",
	"./Raiders.svg": "ak3R",
	"./Roosters.svg": "PwdN",
	"./Sharks.svg": "WTOz",
	"./Storm.svg": "z7zh",
	"./Tigers.svg": "HOe6",
	"./Titans.svg": "Z2Jl",
	"./Warriors.svg": "i9qZ",
	"./codesports.svg": "sd/s"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KZtR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.svg$
// module id = KZtR
// module chunks = 0